/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button } from 'semantic-ui-react';
import { useContext, useEffect, useRef, useState } from '@wordpress/element';
import Map from './Map';
import StaticMap from './StaticMap';
import UserContext from '../context/context';

const MapContainer = () => {
    const containerRef = useRef(null);
    const [width, setWidth] = useState();

    const context = useContext(UserContext);
    const { selectedClassData, updateClass, classTier } = context;

    const legendView = (index, value) => {
        if (3 === index) {
            return (
                <>
                    <span id="leg_nodata">&#9633;</span> No data
                </>
            );
        }
        return (
            <>
                <span>&#9632;</span>
                {value}
                <br />
            </>
        );
    };

    const showLegend = () => {
        return (
            <div className="legend" id={selectedClassData.legend}>
                <div className="legend_title">{selectedClassData.title}</div>
                <div className="legend_colors">
                    {selectedClassData.legendColors.map((value, index) =>
                        legendView(index, value),
                    )}
                </div>
            </div>
        );
    };

    useEffect(() => {
        setWidth(containerRef.current.offsetWidth);
        if (selectedClassData) showLegend();
        const handleResize = () => {
            setWidth(containerRef.current.offsetWidth);
        };
        window.addEventListener('resize', handleResize);
    }, [classTier]);

    return (
        <div id="map_container" ref={containerRef}>
            {430 < width ? (
                <>
                    <div className="button_legend">
                        <fieldset className="toggle" id="toggle1">
                            <label
                                className={
                                    'Lower' === classTier ? 'selected' : ''
                                }
                            >
                                <input
                                    type="radio"
                                    active={'Lower' === classTier}
                                    onClick={() => updateClass('Lower')}
                                />
                                LOWER
                            </label>
                            <label
                                className={
                                    'Middle' === classTier ? 'selected' : ''
                                }
                            >
                                <input
                                    type="radio"
                                    active={'Middle' === classTier}
                                    onClick={() => updateClass('Middle')}
                                />
                                MIDDLE
                            </label>
                            <label
                                className={
                                    'Upper' === classTier ? 'selected' : ''
                                }
                            >
                                <input
                                    type="radio"
                                    active={'Upper' === classTier}
                                    onClick={() => updateClass('Upper')}
                                />
                                UPPER
                            </label>
                        </fieldset>
                        {selectedClassData && showLegend()}
                    </div>

                    <Map />
                </>
            ) : (
                ''
            )}
            <StaticMap />
        </div>
    );
};

export default MapContainer;
